import { render, staticRenderFns } from "./ArchivoAdjuntoCasoSidebar.vue?vue&type=template&id=d5d06196&scoped=true"
import script from "./ArchivoAdjuntoCasoSidebar.vue?vue&type=script&lang=js"
export * from "./ArchivoAdjuntoCasoSidebar.vue?vue&type=script&lang=js"
import style0 from "./ArchivoAdjuntoCasoSidebar.vue?vue&type=style&index=0&id=d5d06196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d06196",
  null
  
)

export default component.exports